import { AppForm } from "../../../../../../../common/forms/app.form";
import { FormArray, FormControl, Validators } from "@angular/forms";
import { max } from "rxjs";

export class TrunkCircumference130Form extends AppForm {
  constructor() {
    super({
      items: new FormArray([])
    });
    this.onAddItem();
  }

  public items: FormArray = this.get('items') as FormArray;

  public getControl(i: number): FormControl {
    return this.items.controls.at(i) as FormControl;
  }

  public onAddItem(event?: Event, v?: string): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.items.push(new FormControl(v || '', {
      nonNullable: true,
      validators: [Validators.required, Validators.maxLength(255)]
    }))
  }

  public onRemoveItem(i: number, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.items.removeAt(i);
  }

  public get values(): string {
    return (this.items.value as string[]).filter(v => !!v).join(',')
  }

  public get itemsSum(): number {
    const v = this.values?.split(',').map(item => +item) || [];
    const maxValue = Math.max(...v);
    let result = 0;
    let maxUsed = false;
    v?.forEach(v => {
      if (maxValue === v && !maxUsed) {
        maxUsed = true;
        result = result + v;
      } else {
        result = result + (v / 2);
      }

    })
    return result;
  }

  public override patchFormValues(val: string) {
    this.items.clear();
    const values = val.split(',');
    values.forEach(value => this.onAddItem(undefined, value));
  }
}
